// extracted by mini-css-extract-plugin
module.exports = {"icon":"Select_icon__5IVfk","root":"Select_root__J1yoO","paper":"Select_paper__Bvoqp","popoverPaper":"Select_popoverPaper__ii1qK","borderless":"Select_borderless__hLB7o"};